import { render, staticRenderFns } from "./buscador-oferta.vue?vue&type=template&id=1af2d443&"
import script from "./buscador-oferta.vue?vue&type=script&lang=js&"
export * from "./buscador-oferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports